export default () => {
    const meta = document.querySelector('meta[name="_DestinationsKey"]');
    if (meta) {
        return meta.getAttribute('content');
    }
}
